/* ==========================================================================
   Product card — snippets/product-card-v2.liquid
   - cambio immagine grande dalle miniature (hover su desktop, tap su mobile)
   - quick add to cart: "+" -> pannello taglie -> click taglia = add to cart
   Caricato da layout/theme.liquid: i listener sono delegati su document,
   quindi valgono per tutte le card della pagina (griglia, caroselli, correlati).
   ========================================================================== */

(function () {
  "use strict";

  // Il file può finire incluso due volte (sezioni multiple): i listener delegati
  // devono essere registrati una sola volta.
  if (window.productCardV2Ready) return;
  window.productCardV2Ready = true;

  var CARD = "[data-pcard]";
  var IS_IT = (document.documentElement.lang || "").toLowerCase().indexOf("it") === 0;

  var FINE_POINTER =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  var openCard = null;
  var hoveredCard = null;

  function closest(node, selector) {
    if (!node) return null;
    var el = node.nodeType === 1 ? node : node.parentElement;
    return el && el.closest ? el.closest(selector) : null;
  }

  /* Immagini
     ====================================================================== */

  function mediaState(media) {
    if (media.pcardState) return media.pcardState;

    var base = media.querySelector("[data-pcard-main]");
    if (!base) return null;

    // Il secondo layer viene creato solo alla prima interazione:
    // le card mai toccate non pagano nessun costo di DOM.
    var alt = base.cloneNode(false);
    alt.removeAttribute("src");
    alt.removeAttribute("srcset");
    alt.removeAttribute("data-pcard-main");
    alt.removeAttribute("fetchpriority");
    alt.setAttribute("alt", "");
    alt.setAttribute("aria-hidden", "true");
    alt.setAttribute("loading", "eager");
    alt.classList.add("is-hidden");
    base.parentNode.appendChild(alt);

    media.pcardState = {
      layers: [base, alt],
      front: 0,
      token: 0,
      original: {
        src: base.getAttribute("src") || "",
        srcset: base.getAttribute("srcset") || ""
      }
    };

    return media.pcardState;
  }

  function showImage(media, src, srcset) {
    if (!src) return;

    var state = mediaState(media);
    if (!state) return;

    // Ogni richiesta annulla lo scambio eventualmente ancora in caricamento,
    // così un'immagine "vecchia" non può comparire dopo che il puntatore è uscito.
    var token = ++state.token;

    var front = state.layers[state.front];
    if ((front.getAttribute("src") || "") === src) return;

    var back = state.layers[1 - state.front];

    var painted = false;

    function paint() {
      if (painted || state.token !== token) return;
      painted = true;

      if (front.sizes) back.sizes = front.sizes;
      if (srcset) {
        back.setAttribute("srcset", srcset);
      } else {
        back.removeAttribute("srcset");
      }
      back.setAttribute("src", src);
      back.classList.remove("is-hidden");
      front.classList.add("is-hidden");
      state.front = 1 - state.front;
    }

    // L'immagine viene scaricata fuori dal DOM: si dipinge solo a download
    // completato, così la dissolvenza non mostra mai un frame vuoto.
    var preload = new Image();
    preload.decoding = "async";
    if (front.sizes) preload.sizes = front.sizes;
    if (srcset) preload.srcset = srcset;

    preload.onload = paint;
    preload.src = src;

    if (preload.complete && preload.naturalWidth > 0) paint();
  }

  // Precarica le 3 immagini grandi delle miniature: lo scambio diventa istantaneo.
  // Parte solo su intenzione reale (hover fermo sulla card o primo tocco), mai in massa.
  function prefetchCard(card) {
    if (!card || card.pcardPrefetched) return;
    card.pcardPrefetched = true;

    var main = card.querySelector("[data-pcard-main]");
    var thumbs = card.querySelectorAll("[data-pcard-thumb]");
    if (!main || !thumbs.length) return;

    function run() {
      for (var i = 0; i < thumbs.length; i++) {
        var image = new Image();
        image.decoding = "async";
        if ("fetchPriority" in image) image.fetchPriority = "low";
        if (main.sizes) image.sizes = main.sizes;

        var srcset = thumbs[i].getAttribute("data-srcset");
        if (srcset) image.srcset = srcset;
        image.src = thumbs[i].getAttribute("data-src");
      }
    }

    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(run, { timeout: 500 });
    } else {
      window.setTimeout(run, 0);
    }
  }

  function markThumb(card, thumb) {
    var thumbs = card.querySelectorAll("[data-pcard-thumb]");
    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].classList.toggle("is-active", thumbs[i] === thumb);
    }
  }

  function pickThumb(thumb, pin) {
    var card = closest(thumb, CARD);
    if (!card) return;

    var media = card.querySelector("[data-pcard-media]");
    if (!media) return;

    markThumb(card, thumb);
    showImage(media, thumb.getAttribute("data-src"), thumb.getAttribute("data-srcset"));

    if (pin) card.pcardPinned = true;
    hoveredCard = card;
  }

  function restoreCard(card) {
    if (!card || card.pcardPinned) return;

    var media = card.querySelector("[data-pcard-media]");
    var state = media && media.pcardState;
    if (!state) return;

    markThumb(card, null);
    showImage(media, state.original.src, state.original.srcset);
  }

  /* Pannello taglie
     ====================================================================== */

  var viewportWatcher =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              var entry = entries[i];

              // La prima callback descrive solo lo stato al momento dell'apertura.
              if (!entry.target.pcardObserved) {
                entry.target.pcardObserved = true;
                continue;
              }

              // isIntersecting resta true finché è visibile anche un solo pixel:
              // serve il rapporto per capire che la card è ormai fuori schermo.
              if (!entry.isIntersecting || entry.intersectionRatio < 0.15) {
                closePanel(entry.target);
              }
            }
          },
          { threshold: [0, 0.15] }
        )
      : null;

  function setMessage(card, text, isError) {
    var node = card.querySelector("[data-pcard-message]");
    if (!node) return;

    if (!node.pcardDefault) node.pcardDefault = node.textContent;
    node.textContent = text || node.pcardDefault;
    node.classList.toggle("is-error", !!isError);

    window.clearTimeout(card.pcardMessageTimer);
    if (text) {
      card.pcardMessageTimer = window.setTimeout(function () {
        node.textContent = node.pcardDefault;
        node.classList.remove("is-error");
      }, 3000);
    }
  }

  function closePanel(card) {
    if (!card) return;

    card.classList.remove("is-qa-open");

    var trigger = card.querySelector("[data-pcard-trigger]");
    if (trigger) trigger.setAttribute("aria-expanded", "false");

    if (viewportWatcher) {
      viewportWatcher.unobserve(card);
      card.pcardObserved = false;
    }

    if (openCard === card) openCard = null;
  }

  function openPanel(card, fromKeyboard) {
    if (openCard && openCard !== card) closePanel(openCard);

    card.classList.add("is-qa-open");

    var trigger = card.querySelector("[data-pcard-trigger]");
    if (trigger) trigger.setAttribute("aria-expanded", "true");

    setMessage(card, null, false);
    openCard = card;

    if (viewportWatcher) viewportWatcher.observe(card);

    if (fromKeyboard) {
      var first = card.querySelector(".pcard__qa-size[data-pcard-add]");
      if (first) first.focus({ preventScroll: true });
    }
  }

  /* Add to cart
     ====================================================================== */

  function cartRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return root.charAt(root.length - 1) === "/" ? root : root + "/";
  }

  function openDrawer() {
    var wrapper = document.querySelector("drawer-wrapper");
    if (wrapper) wrapper.classList.add("active");
  }

  function updateCounter() {
    return fetch(cartRoot() + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var counter = document.querySelector(".js-cart-count");
        if (counter) counter.innerText = cart.item_count;

        var bag = document.querySelector(".header__bag");
        if (bag && cart.item_count > 0) bag.classList.add("has-items");
      })
      .catch(function () {});
  }

  function refreshCart() {
    var refresh = null;

    // getCart() è definita in assets/drawer.js e ridisegna anche il contenuto del drawer.
    try {
      if (typeof getCart === "function") refresh = getCart;
    } catch (error) {
      refresh = null;
    }

    if (!refresh && typeof window.getCart === "function") refresh = window.getCart;

    if (refresh) {
      try {
        var result = refresh();
        if (result && typeof result.then === "function") {
          return result.catch(function () {});
        }
        return Promise.resolve();
      } catch (error) {
        /* fallback sotto */
      }
    }

    return updateCounter();
  }

  function trackConversion(price) {
    // Stesso evento di conversione dell'add to cart della PDP (assets/cart.js).
    try {
      if (typeof gtag !== "function") return;
      gtag("event", "conversion", {
        send_to: "AW-933434264/IpEYCLi76KUDEJinjL0D",
        value: parseFloat(price || 0) / 100,
        currency:
          (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR"
      });
    } catch (error) {
      /* il tracking non deve mai bloccare l'add to cart */
    }
  }

  function addToCart(button) {
    if (button.classList.contains("is-loading") || button.classList.contains("is-added")) return;

    var variantId = parseInt(button.getAttribute("data-variant-id"), 10);
    if (!variantId) return;

    var card = closest(button, CARD);
    var payload = { items: [{ id: variantId, quantity: 1 }] };

    try {
      if (typeof offporterGetRvdt === "function") {
        payload.attributes = { offporterRvdt: offporterGetRvdt() };
      }
    } catch (error) {
      /* attributo opzionale */
    }

    button.classList.add("is-loading");

    fetch(cartRoot() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            return { ok: response.ok, status: response.status, data: data };
          });
      })
      .then(function (result) {
        button.classList.remove("is-loading");

        if (!result.ok) {
          if (result.status === 422) {
            button.setAttribute("disabled", "disabled");
            button.removeAttribute("data-pcard-add");
            setMessage(
              card,
              IS_IT ? "Taglia non più disponibile" : "Size no longer available",
              true
            );
          } else {
            setMessage(card, IS_IT ? "Si è verificato un errore" : "Something went wrong", true);
          }
          return;
        }

        button.classList.add("is-added");
        trackConversion(button.getAttribute("data-price"));

        refreshCart().then(openDrawer);

        window.setTimeout(function () {
          button.classList.remove("is-added");
          closePanel(card);
        }, 900);
      })
      .catch(function () {
        button.classList.remove("is-loading");
        setMessage(card, IS_IT ? "Si è verificato un errore" : "Something went wrong", true);
      });
  }

  /* Eventi (delegati: un solo listener per tutta la griglia)
     ====================================================================== */

  document.addEventListener("click", function (event) {
    var target = event.target;

    // Qualsiasi click fuori dalla card aperta chiude il pannello.
    if (openCard && closest(target, CARD) !== openCard) closePanel(openCard);

    var addButton = closest(target, "[data-pcard-add]");
    if (addButton) {
      event.preventDefault();
      addToCart(addButton);
      return;
    }

    var trigger = closest(target, "[data-pcard-trigger]");
    if (trigger) {
      event.preventDefault();
      var triggerCard = closest(trigger, CARD);
      if (!triggerCard) return;

      if (triggerCard.classList.contains("is-qa-open")) {
        closePanel(triggerCard);
      } else {
        openPanel(triggerCard, event.detail === 0);
      }
      return;
    }

    var closeButton = closest(target, "[data-pcard-close]");
    if (closeButton) {
      event.preventDefault();
      closePanel(closest(closeButton, CARD));
      return;
    }

    var thumb = closest(target, "[data-pcard-thumb]");
    if (thumb) {
      event.preventDefault();
      pickThumb(thumb, true);
    }
  });

  document.addEventListener("keydown", function (event) {
    if (!openCard) return;
    if (event.key !== "Escape" && event.key !== "Esc") return;

    var card = openCard;
    closePanel(card);

    var trigger = card.querySelector("[data-pcard-trigger]");
    if (trigger) trigger.focus({ preventScroll: true });
  });

  document.addEventListener(
    "pointerdown",
    function (event) {
      prefetchCard(closest(event.target, CARD));
    },
    { passive: true }
  );

  if (FINE_POINTER) {
    var prefetchTarget = null;
    var prefetchTimer = null;

    document.addEventListener(
      "pointerover",
      function (event) {
        var card = closest(event.target, CARD);

        if (card && !card.pcardPrefetched && prefetchTarget !== card) {
          prefetchTarget = card;
          window.clearTimeout(prefetchTimer);
          prefetchTimer = window.setTimeout(function () {
            prefetchCard(card);
          }, 160);
        }

        var thumb = closest(event.target, "[data-pcard-thumb]");
        if (thumb) {
          pickThumb(thumb, false);
          return;
        }

        if (!hoveredCard) return;

        if (card !== hoveredCard) {
          restoreCard(hoveredCard);
          hoveredCard = card;
        }
      },
      { passive: true }
    );
  }
})();
